import { useTranslation } from "react-i18next";
import { RemoteApiError } from "../useRemote/types";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { RoomLayoutAssignmentDto } from "../../../components/FacilityManager/Domain/Types/FloorPlan/RoomlayoutAssignment.type";

export function useRemoteAssignRoomlayoutService() {
  const { t } = useTranslation();

  return useRemoteMutation<void, RemoteApiError, RoomLayoutAssignmentDto>({
    url: `/room-layouts/zone-schedule`,
    key: ["conferenceroom", "assign-room-layouts"],
    method: "put",
    snackbarTextOnFail: t("AssignRoomlayoutFail")
  });
}
